import React, {useEffect, useState} from 'react'
import { Route } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Container, Dimmer, Divider, Form, Header, Icon, Image, Button, Loader, Search, Segment, Grid } from 'semantic-ui-react'
import PartnerDetailPage from './PartnerDetail'

const PartnerPage = () =>{
    const [partners, setPartners] = useState([])
    const [parterList, setPartnerList] = useState([])
    const [loading, setLoading] = useState(true)
    const [resultSearch, setResultSearch] = useState([])
    const [loadingSearch, setLoadingSearch] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    const [selectValue, setSelectValue] = useState('')
    const [listSearchResult, setListSearchResult] = useState([])
    const [activeChallenge, setActiveChallenge] = useState(null)
    const [isEmptyResult, setIsEmptyResult] = useState(false)

    useEffect(()=>{
        loadPartners()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const loadPartners = () =>{
        fetch(process.env.REACT_APP_CRM_URL+'api/manage_challenge/get_live')
        .then((res)=>{
            return res.json()
        })
        .then((res)=>{
            let data = res.data
            let tempPartner = []
            let partners = []
            data.forEach(x=>{
                tempPartner.push({
                    key: x.Record_KEY, 
                    text: x.Title, 
                    value: x.LA_Code
                })

                partners.push(x)
            })

            setPartners(data)
            setPartnerList(tempPartner)
            setLoading(false)
        })
        .catch((e)=>{
            toast.error('Something wrong on fetching partners, please contact developer.')
        })
    }

    const resultRenderer = ({ title }) =>{
        let replace = searchValue.toLocaleLowerCase();
        let re = new RegExp(replace,"g");
        let splitted = title.toLowerCase().replace(re, "<b>"+replace+"</b>");
        return <p dangerouslySetInnerHTML={{__html: splitted}}/>
    }

    const handleSearchChange = (e, data) =>{
        setIsEmptyResult(false)
        setLoadingSearch(true)
        setSearchValue(data.value)
        let temp = partners.filter(x=>x.Title.toLowerCase().includes(data.value.toLowerCase()))
        let result = []
        temp.forEach(x=>{
            result.push({
                id: x.LA_Code,
                title: x.Title
            })
        })
        setResultSearch(result)
        setLoadingSearch(false)
    }

    const searchClickHandle = () =>{
        if(searchValue === ''){
            return false
        }
        setActiveChallenge(null)
        setSelectValue('')
        let data = partners.filter(x=>x.Title.toLocaleLowerCase().includes(searchValue.toLocaleLowerCase()))
        setListSearchResult(data)
        if(data.length === 0){
            setIsEmptyResult(true)
        }else{
            setIsEmptyResult(false)
        }
    }

    const onChangeDropdown = (e, data) =>{
        setChallenge(data.value)
        setSearchValue('')
    }

    const setChallenge = (code, e) =>{
        setSelectValue(code)
        let result = partners.filter(x=>x.LA_Code === code)
        setActiveChallenge(result[0])
    }

    return(
        <div className='partnerContainer'>
            <Container>
                <Dimmer.Dimmable as={Segment} dimmed={loading}>
                    <Form size="big" className="partnerForm">
                        <Form.Group>
                            <Form.Dropdown onChange={onChangeDropdown} value={selectValue} placeholder='Select the challenge' fluid selection options={parterList} width={12}/>
                            <Form.Field width={6}>
                            <Search icon={<Icon id="searchBtn" onClick={searchClickHandle} link name='search'/>} placeholder='Or search the challenge'
                            loading={loadingSearch} results={resultSearch} resultRenderer={resultRenderer} value={searchValue}
                            onResultSelect={(e, data) =>{
                                setSearchValue(data.result.title)
                                setChallenge(data.result.id)
                            }} onSearchChange={handleSearchChange}/>
                            </Form.Field>
                        </Form.Group>
                    </Form>
                    <Divider hidden/>
                    {activeChallenge === null ? 
                    <Dimmer.Dimmable as={Container} dimmed>
                        {listSearchResult.length > 0 ? 
                        <div>
                            <i className='textResult'>This is your result for “<b>{searchValue}</b>”</i>
                        {listSearchResult.map((v, k)=>
                            <Segment key={k} className="resultSegment">
                                <Grid columns='equal'>
                                    <Grid.Column>
                                        <Header as="h2">
                                            <Icon name='trophy' color='orange'/> {v.Title}
                                        </Header>
                                    </Grid.Column>
                                    <Grid.Column width='4'>
                                        <Button primary onClick={setChallenge.bind(null, v.LA_Code)}>Go to challenge</Button>
                                    </Grid.Column>
                                </Grid>
                            </Segment>
                        )}
                        </div>
                        : isEmptyResult ? 
                        <>
                        <Header as="h1" textAlign='center' color='grey'>
                        Sorry, we can’t find the challenge for “{searchValue}”
                        </Header>
                        <Image centered src={require('./assets/images/empty_partner.svg').default} size="large"/>
                        </>
                        : 
                        <>
                        <Header as="h1" textAlign='center' color='grey'>
                        Please select the challenge
                        </Header>
                        <Image centered src={require('./assets/images/partner_svg.svg').default} size="large"/>
                        </>
                        }
                    </Dimmer.Dimmable>
                    : null}
                    
                    <Dimmer active={loading} inverted>
                        <Loader active>Fetching Challenge Data...</Loader>
                    </Dimmer>
                </Dimmer.Dimmable>
            </Container>
            
            {activeChallenge !== null ? 
            <PartnerDetailPage data={activeChallenge}/>
            : null}
            <Route path="/partner/:code" render={(props)=><PartnerDetailPage data={partners} {...props}/>}/>
        </div>
    )
}

export default PartnerPage

